import helper from '../../helpers/helper';

document.addEventListener('turbolinks:load', () => {
  if (helper.notPresent($('[data-js="pitch-show-more-button"]')) && helper.notPresent($('[data-js="audit-card-toggle"]'))) {
    return;
  }

  function expandAllPitches() {
    $('[data-js="pitch-show-more-button"]')
      .filter('.collapsed')
      .click();

    $('#expando-collapso-button')
      .html('Collapse all');
    $('#expando-collapso-button')
      .removeClass('collapsed');
    $('#expando-collapso-button')
      .addClass('expanded');
  }

  function collapseAllPitches() {
    $('[data-js="pitch-show-more-button"]')
      .filter('.expanded')
      .click();

    $('#expando-collapso-button')
      .html('Expand all');
    $('#expando-collapso-button')
      .removeClass('expanded');
    $('#expando-collapso-button')
      .addClass('collapsed');
  }

  $('#pills-views-tab')
    .on('click', () => {
      window.location = `${window.location.pathname}?tabname=views`;
    });

  $('#expando-collapso-button')
    .on('click', () => {
      if ($('#expando-collapso-button')
        .hasClass('collapsed')) {
        expandAllPitches();
      } else {
        collapseAllPitches();
      }
    });

  $('[data-js="audit-card-toggle"]').on('click', function handleAuditCardToggleClick() {
    const $toggle = $(this);
    const pitchId = $toggle.data('pitch-id');
    const $body = $(`#audit-card-body-${pitchId}`);
    const $banner = $(`#audit-card-banner-${pitchId}`);
    const $chevron = $toggle.find('i');
    const $label = $toggle.find('[data-js="audit-card-toggle-label"]');
    const isExpanded = $toggle.attr('aria-expanded') === 'true';

    if (isExpanded) {
      $body.addClass('d-none');
      $banner.addClass('rounded-bottom');
      $chevron.removeClass('fa-chevron-up').addClass('fa-chevron-right');
      $toggle.attr('aria-expanded', 'false');
      $label.text($toggle.data('label-collapsed'));
    } else {
      $body.removeClass('d-none');
      $banner.removeClass('rounded-bottom');
      $chevron.removeClass('fa-chevron-right').addClass('fa-chevron-up');
      $toggle.attr('aria-expanded', 'true');
      $label.text($toggle.data('label-expanded'));
    }
  });

  $('#selected-pitches-form').submit(() => {
    const checked = $('#selected-pitches-form input:checked').length > 0;
    if (!checked) {
      return false;
    }
  });
});
